/* eslint-disable import/prefer-default-export */
import qs from 'qs';
import contentService from '../../services/contentService';
import {
  FETCH_ARTICLES_GESUNDE_KOMMUNE_CLEAN_UP,
  FETCH_ARTICLES_GESUNDE_KOMMUNE_FAILURE,
  FETCH_ARTICLES_GESUNDE_KOMMUNE_REQUEST,
  FETCH_ARTICLES_GESUNDE_KOMMUNE_SUCCESS,
  UPDATE_GESUNDE_KOMMUNE_PAGE_START_PARAM,
} from '../constants/gesundeKommuneTypes';

const fetchArticlesGesundeKommuneRequest = () => {
  return {
    type: FETCH_ARTICLES_GESUNDE_KOMMUNE_REQUEST,
  };
};

const fetchArticlesGesundeKommuneSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_GESUNDE_KOMMUNE_SUCCESS,
    payload,
  };
};

const fetchArticlesGesundeKommuneFailure = (error) => {
  return {
    type: FETCH_ARTICLES_GESUNDE_KOMMUNE_FAILURE,
    payload: error,
  };
};

export const fetchArticlesGesundeKommuneCleanUp = () => {
  return {
    type: FETCH_ARTICLES_GESUNDE_KOMMUNE_CLEAN_UP,
  };
};

export const updateGesundeKommunePageStartParam = () => {
  return {
    type: UPDATE_GESUNDE_KOMMUNE_PAGE_START_PARAM,
  };
};

export const fetchArticlesGesundeKommune = ({
  categories = [],
  city = undefined,
  start = undefined,
  limit = undefined,
  menu = 'gesundekommune',
  locale = 'de',
} = {}) => {
  return (dispatch) => {
    let categoriesList = [];
    let query = '';
    categoriesList = categories.map((item) => item.id);
    if (categoriesList.length > 0) {
      query = qs.stringify(
        {
          _where: { 'categories.id': categoriesList },
        },
        { encode: false, arrayFormat: 'repeat' }
      );
    }
    const contentsQuery = `sort=publishAt%3Adesc&filters[type][$eq]=article&populate[main_image]=true${
      categoriesList.length > 0 ? `&${query}` : ''
    }${menu ? `&filters[menu][$eq]=${menu}` : ''}${
      city ? `&filters[city][$eq]=${city}` : ''
    }${start ? `&pagination[start]=${start}` : ''}${
      limit ? `&pagination[limit]=${limit}` : ''
    }`;
    dispatch(fetchArticlesGesundeKommuneRequest);
    contentService
      .getContents(contentsQuery, locale)
      .then((response) => {
        const articles = response.data;
        dispatch(
          fetchArticlesGesundeKommuneSuccess({
            articles,
            limit,
            start,
          })
        );
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesGesundeKommuneFailure(errorMsg));
      });
  };
};
